<template>
  <div
    class="switch-version-box"
    v-if="showSwitchVersion"
    @click="switchVersion"
  >
    <a href="javascript:;" class="switch-version-btn" :class="gameCode">
      <div class="switch-version-btn-text" :class="[lang]">
        <p>{{ letter.switchNewVersion }}</p>
        <p>{{ letter.switchNewVersionPlatform }}</p>
      </div>
    </a>
  </div>
</template>

<script>
import switchVersion from '@mixins/officialStore/switchVersion';
export default {
  mixins: [switchVersion],
  name: 'SwitchVersion',
  computed: {
    letter() {
      return this.$store.state.letter;
    },
    lang() {
      return this.$store.state.lang;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/_dimen.scss';
.switch-version-box {
  position: fixed;
  z-index: 9;
  height: 50px;
  right: 0;
  top: 440px;
}

.switch-version-btn {
  float: right;
  width: 168px;
  height: 204px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  cursor: pointer;

  &.ztmslg {
    background-image: url($pnsImg + 'm-switch-version.png');
  }

  &.dtmslg {
    background-image: url($dtmslgImg + 'm-switch-version.png');
  }

  &.antslg {
    background-image: url($antImg + 'm-switch-version.png');
  }

  &-text {
    margin-top: 98px;
    user-select: none;
    &.vi-VN,
    &.it-IT {
      margin-top: 86px;
    }
    &.zh-CN,
    &.zh-TW {
      margin-top: 106px;
    }
    &.pt-PT {
      margin-top: 88px;
    }
    p {
      display: block;
      font-size: 22px;
      line-height: 20px;
      padding: 0 8px;
      // 文字渐变色
      font-weight: bold;
      -webkit-background-clip: text;
      color: transparent; /* Fallback for non-webkit browsers */
      background-clip: text;
      -webkit-text-fill-color: transparent;
      background-image: linear-gradient(to bottom, #ffe070, #ffffff);
      &:nth-child(1) {
        margin-bottom: 8px;
      }
    }
  }
}
</style>
